import { Component, OnInit, OnDestroy, Input, Inject, ElementRef } from '@angular/core';
import { UtilsService } from '../../../../shared/services/utils-service';
// Services
import { CatalogService } from '../../services/catalog-service';
import { AppService } from '../../../../shared/services/app-service';
import { DOCUMENT } from "@angular/platform-browser";
import { PageScrollService, PageScrollInstance } from "ng2-page-scroll";
import { AnimateService } from '../../../../shared/services/animate-service';
let Ps = require('perfect-scrollbar');
let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:ProductCategoryCmp'));
declare var $;
/**
 * Used to render the product categories from the catalog.
 * Standard angular component, no direct access to state store.
 * Categories with subcategories can be rendered recursively.
 * Renders categories either as thumbnails in compact mode or with full content in expanded mode.
 * Compact subcategories can be selected to render their contents.
 * This behavior allows for flexible rendering options for the categories three.
 * Compact mode is useful to render a big collection of products or render in mobile mode.
 * Expanded mode renders all categories at once on screen. Useful for smaller collections of products.
 * Expanded categories can render recursively.
 */
@Component({
    selector: 'product-category-cmp',
    template: require('./product-category.cmp.html'),
    styles: [String(require('./product-category.cmp.scss'))],
    host: { class: 'product-category' }
})
export class ProductCategoryCmp {

    @Input() catalogState;
    @Input() category;
    @Input() level;

    private _subscriptions: any = {};
    private _subcategories = null;
    private _compactSubcategories = null;
    private _expandedSubcategories = null;
    private _categoryElem = null;


    constructor(
        private _elementRef: ElementRef,
        private _catalogService: CatalogService,
        private _appService: AppService,
        private _animateService: AnimateService,
        private pageScrollService: PageScrollService,
        private _utilsService: UtilsService,
        @Inject(DOCUMENT) private document: any
    ) {
        //'Construct product category component');
        this._subscribeToEvents();
    }


    ngOnInit() {
        //'Initialise "' + this.category.id + '" product category component');
        debugOff('Category:', this.category);
        this._shallowCloneSubcategories();
        this._cacheDomElements();
    }


    ngOnDestroy() {
        //'Destroy product category component');

        // Unsubscribe events
        for (let subId in this._subscriptions) {
            this._subscriptions[subId].unsubscribe();
        }
    }


    private _cacheDomElements() {
        //'Cache DOM elements');

        // Cache cateogry element
        this._categoryElem = this._elementRef.nativeElement;
        debugOff('Product categories list element:', this._categoryElem);
    }

    
    private _selectCategory (category) {
        //'Select "' + category.id + '" category');

        // Reset highlight
        if (this._catalogService.prevSelectedCategory !== undefined) {
            this._catalogService.prevSelectedCategory.isSelected = false;
        }

        // Highilight selected category
        category.isSelected = true;

        this._catalogService.prevSelectedCategory = category;

        // Emit category change event
        this._catalogService.events.categorySelected.emit({
            category: category
        });
    }


    private _subscribeToEvents() {
        debugOff('Subscribe to events');

        // Subcategory selected
        this._subscriptions.categorySelected = this._catalogService.events.categorySelected.subscribe(event => {
            event.category.parentCategoryId === this.category.id &&
                this._renderSelectedSubcategory(event.category)
        });
    }

    // TODO: Fix problem with rendering hidden categories on demand. Since they are not present in the filtered array they cannot be reenabled easily.
    /** Operation is required to enable rendering both compact and expanded categories.
     * Shallow clone is used to maintain references to other objects.
     */
    private _shallowCloneSubcategories() {
        debugOff('Shallow clone "' + this.category.id + '" subcategories list');
        let self = this;

        // Clone subcategories
        this._subcategories = this._catalogService.shallowCloneSubcategories(this.category)

            // Filter hidden categories
            // .filter( subcategory => { return subcategory.isVisible === true } );
            .filter(subcategory => { return true });

        debugOff('Subcategories:', this._subcategories);

        // Clear previous values
        this._compactSubcategories = [];
        this._expandedSubcategories = [];

        // Sort between compact and expanded
        this._subcategories.forEach(subcategory => {

            // Check if category renders as compact or if all categories are rendered compact globally.
            if (subcategory.renderMode === 'compact' ||
                self.catalogState.renderMode === 'compact'
            ) {
                self._compactSubcategories.push(subcategory);
            } else if (subcategory.renderMode === 'expanded') {
                self._expandedSubcategories.push(subcategory);
            }
        });

        debugOff('Compact subcategories:', this._compactSubcategories);
        debugOff('Expanded subcategories:', this._expandedSubcategories);
    }


    private _renderSelectedSubcategory(subcategory) {
        debugOff('Render selected subcategory');

        // Reset subcategories
        this._shallowCloneSubcategories();

        // Shallow clone selected subcategory.
        let selectedSubcategory = this._catalogService.shallowCloneCategory(subcategory);

        // Override rendering mode for a cloned subcategory without affecting the original.
        selectedSubcategory.renderMode = 'expanded';

        // Expand subcategory contents
        this._expandedSubcategories.splice(0, 0, selectedSubcategory);
    }

    /** HARDCODED <!> Must be improved.  */
    private displayCategoryDetails(category) {

        console.log('displayCategoryDetails(), category:', category);

        // TODO: Porper method and modal for categories details
        // <!> This is a total hack, because of time pressure, a category is trasnformed to a product and displayed using product-details-modal
        let product: any = {
            name: category.title,
            images: {
                folder: false,
                thumbnail: category.image
            },
            descriptions: {
                long: category.longDescription,
                tech: null
            }
        }

        this._appService.displayProductDetailsModal(product);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/components/product-categories/product-category.cmp.ts